export const roundToOneDecimal = (number) => (Math.round(number * 10) / 10).toFixed(1)
